import { defineStore } from "pinia";

export const userCheckoutStore = defineStore("checkout-store", {
  state: () => ({
    productsInCart: {
      fiskarsmoominse: [],
      fiskarsmoominno: [],
      fiskarsmoominfi: [],
      fiskarsmoomingb: [],
      fiskarsmoominen: [],
    },
    cartItemsCount: {
      fiskarsmoominse: 0,
      fiskarsmoominno: 0,
      fiskarsmoominfi: 0,
      fiskarsmoomingb: 0,
      fiskarsmoominen: 0,
    },
    currentCart: {},
    availablePaymentMethods: {
      fiskarsmoominse: [],
      fiskarsmoominno: [],
      fiskarsmoominfi: [],
      fiskarsmoomingb: [],
      fiskarsmoominen: [],
    },
    finalSummary: {
      shippingAdress: {},
      billingAddress: {},
      personalInfo: {},
      shippingInformationTitle: "",
      shippingMethod: "",
      paymentMethod: {},
    },
    billingOption: null,
    currentShippingTab: null,
    selectedDeliveryMode: {
      code: "",
      deliveryCost: {
        currencyIso: "",
        exclusiveButVisible: false,
        formattedValue: "",
        priceType: "",
        value: "",
      },
      deliveryType: "",
      isPreferredDeliveryMode: false,
      name: "",
      description: "",
    },
    guestUser: {
      uid: null,
      email: null,
    },
    adyenOrder: {
      fiskarsmoominse: {
        orderId: null,
        orderData: null,
        orderInfo: null,
        pspRef: null,
        chosenPaymentMethod: null,
      },
      fiskarsmoominno: {
        orderId: null,
        orderData: null,
        orderInfo: null,
        pspRef: null,
        chosenPaymentMethod: null,
      },
      fiskarsmoominfi: {
        orderId: null,
        orderData: null,
        orderInfo: null,
        pspRef: null,
        chosenPaymentMethod: null,
      },
      fiskarsmoomingb: {
        orderId: null,
        orderData: null,
        orderInfo: null,
        pspRef: null,
        chosenPaymentMethod: null,
      },
      fiskarsmoominen: {
        orderId: null,
        orderData: null,
        orderInfo: null,
        pspRef: null,
        chosenPaymentMethod: null,
      },
    },
      pickupShippingAddress: {
      firstName: null,
      lastName: null,
      street: null,
      streetAdditional: null,
      postalCode: null,
      postalCodeSearch: null,
      city: null,
      country: null,
      phonePrefix: null,
      phone: null,
      name: null,
      storePickUpId: null,
    },
    currentShippingAddress: {
      firstName: null,
      lastName: null,
      street: null,
      streetAdditional: null,
      postalCode: null,
      city: null,
      country: null,
      phonePrefix: null,
      phone: null,
    },
    currentBillingAddress: {
      firstName: null,
      lastName: null,
      street: null,
      streetAdditional: null,
      postalCode: null,
      city: null,
      country: null,
      phonePrefix: null,
      phone: null,
    },
    selectedStore: null,
    isPaymentInit: false,
  }),
  actions: {
    addSelectedStore(value) {
      this.selectedStore = value;
    },
    setPaymentInitStatus(value) {
      this.isPaymentInit = value;
    },
    setCurrentActiveShippingTab(value) {
      this.currentShippingTab = value;
    },
    updateBillingOption(value) {
      this.billingOption = value;
    },
    resetAllData(appKey, isFullReset = true) {
      this.removeAllProductsInCart(appKey);
      this.removeCurrentCart();
      this.billingOption = null;
      this.selectedStore = null;
      this.isPaymentInit = false;
      this.currentShippingTab = null;
      this.resetPickupAddress();
      this.resetShippingAddress();
      this.resetBillingAddress();
      this.resetAdyenOrderData();
      if(isFullReset){
        this.selectedDeliveryMode = {};
        this.resetGuestUser();
      }
    },
    resetGuestUser() {
      this.guestUser.uid = null;
      this.guestUser.email = null;
    },
    removeCurrentCart() {
      this.currentCart = {};
    },
    setCurrentCart(mode) {
      this.currentCart = mode;
    },
    setSelectedDeliveryMode(mode) {
      this.selectedDeliveryMode = mode;
    },
    setGuestUser(data) {
      this.guestUser = data;
    },
    setAdyenOrderInfo(payload) {
      const appKey = payload.appKey;
      const orderInfo = payload.orderObj;
      this.adyenOrder[appKey] = orderInfo;
    },
    setFinalSummary(finalSummary) {
      this.finalSummary = finalSummary;
    },
    setAvailablePaymentMethods(payload) {
      const localePaymentMethods = payload.availablePaymentMethods;
      const appKey = payload.appKey;
      /* I think thios condition is not needed, as we already updating using appKey , so it will not override other locale */
      // if (
      //   this.availablePaymentMethods[appKey].length === 0
      // ) {
        this.availablePaymentMethods[appKey] = localePaymentMethods;
      // }
    },
    addCurrentShippingAddress(data) {
      this.currentShippingAddress = data;
    },
    addPickupAddress(data) {
      this.pickupShippingAddress = data;
    },
    resetShippingAddress() {
      this.currentShippingAddress = {
        firstName: null,
        lastName: null,
        street: null,
        streetAdditional: null,
        postalCode: null,
        city: null,
        country: null,
        phonePrefix: null,
        phone: null,
      };
    },
    resetPickupAddress() {
      this.pickupShippingAddress = {
        firstName: null,
        lastName: null,
        street: null,
        streetAdditional: null,
        postalCode: null,
        postalCodeSearch: null,
        city: null,
        country: null,
        phonePrefix: null,
        phone: null,
        name: null,
      };
    },
    resetSelectedDeliveryMode() {
      this.selectedDeliveryMode = {
        code: "",
        deliveryCost: {
          currencyIso: "",
          exclusiveButVisible: false,
          formattedValue: "",
          priceType: "",
          value: "",
        },
        deliveryType: "",
        isPreferredDeliveryMode: false,
        name: "",
        description: "",
      };
    },
    resetBillingAddress() {
      this.currentBillingAddress = {
        firstName: null,
        lastName: null,
        street: null,
        streetAdditional: null,
        postalCode: null,
        city: null,
        country: null,
        phonePrefix: null,
        phone: null,
      };
    },
    resetAdyenOrderData() {
      this.adyenOrder = {
      fiskarsmoominse: {
        orderId: null,
        orderData: null,
        orderInfo: null,
        pspRef: null,
        chosenPaymentMethod: null,
      }
    },
    {
      fiskarsmoominno: {
        orderId: null,
        orderData: null,
        orderInfo: null,
        pspRef: null,
        chosenPaymentMethod: null,
      }
    },
    {
      fiskarsmoominfi: {
        orderId: null,
        orderData: null,
        orderInfo: null,
        pspRef: null,
        chosenPaymentMethod: null,
      },
      fiskarsmoomingb: {
        orderId: null,
        orderData: null,
        orderInfo: null,
        pspRef: null,
        chosenPaymentMethod: null,
      },
      fiskarsmoominen: {
        orderId: null,
        orderData: null,
        orderInfo: null,
        pspRef: null,
        chosenPaymentMethod: null,
      },
    };
    },
    addBillingAddress(data) {
      this.currentBillingAddress = data;
    },
    setProductsInCart(payload) {
      const productCode = payload.pCode;
      const appKey = payload.appKey;
      if (
        this.productsInCart[appKey].length === 0 ||
        !this.productsInCart[appKey].includes(productCode)
      ) {
        this.productsInCart[appKey].push(productCode);
      }
    },

    removeProductsInCart(payload) {
      const productCode = payload.pCode;
      const appKey = payload.appKey;
      const index = this.productsInCart[appKey].indexOf(productCode);
      if (index !== -1) {
        this.productsInCart[appKey].splice(index, 1);
      }
    },
    removeAllProductsInCart(appKey) {
      this.productsInCart[appKey] = [];
      this.setCartItemsCount({
        appKey,
        itemCount: 0
      });
    },
    setCartItemsCount(payload) {
      const appKey = payload.appKey;
      const count = payload.itemCount;
      this.cartItemsCount[appKey] = count;
    },
    resetCheckoutStates() {
      this.setCurrentActiveShippingTab(null);
      this.resetSelectedDeliveryMode()
      this.resetPickupAddress();
      this.resetShippingAddress();
      this.resetBillingAddress();
    },
  },
  getters: {
    getSelectedStore() {
      return this.selectedStore;
    },
    getPaymentInitStatus() {
      return this.isPaymentInit;
    },
    getCurrentActiveShippingTab() {
      return this.currentShippingTab;
    },
    getBillingOption() {
      return this.billingOption;
    },
    getCurrentCartCountryCode() {
      return this.currentCart?.deliveryAddress?.country?.isocode;
    },
    getDeliveryModeCode: (state) => {
      return state.selectedDeliveryMode?.code
        ? state.selectedDeliveryMode?.code
        : state.currentCart?.deliveryMode?.code;
    },
    getDeliveryModeType: (state) => {
      return state.selectedDeliveryMode?.deliveryType
        ? state.selectedDeliveryMode?.deliveryType
        : state.currentCart?.deliveryModeType;
    },
    getFinalSummary: (state) => {
      return state.finalSummary;
    },
    getAvailablePaymentMethods: (state) => (appKey) => {
      return state.availablePaymentMethods[appKey] ? state.availablePaymentMethods[appKey] : [];
    },
    getSelectedDeliveryMode: (state) => state.selectedDeliveryMode,
    getCurrentCart: (state) => {
      return state.currentCart;
    },
    getCartItemsCount: (state) => (appKey) => {
      return state.cartItemsCount[appKey] ? state.cartItemsCount[appKey] : 0;
    },
    getCartGuid: (state) => {
      return state.currentCart?.guid;
    },
    getCartCode: (state) => {
      return state.currentCart?.code;
    },
    getGuestUserUid: (state) => {
      return state.guestUser?.uid;
    },
    getGuestUserEmail: (state) => {
      return state.guestUser?.email;
    },
    getCurrentShippingAddr: (state) => {
      return state.currentShippingAddress;
    },
    getPickupAddress: (state) => {
      return state.pickupShippingAddress;
    },
    getCurrentBillingAddr: (state) => {
      return state.currentBillingAddress;
    },
    getShippingType: (state) => {
      return state.shippingTypeId;
    },
    getAdyenOrderInfo: (state) => (appKey) => {
      return state.adyenOrder[appKey] ? state.adyenOrder[appKey] : [];
    },
  },
});
